//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('skillsCertificates', {
//        templateUrl: 'views/components/views/skillsCertificates/skillsCertificates.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'skillsCertificatesService', 'ttGridFactory', 'logisticService', function ($stateParams, stateService, skillsCertificatesService, ttGridFactory, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                setting: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_skillscertificates_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'skillscertificates_new',
//                text: 'skillscertificates_new',
//                func: () => {
//                    logisticService.getNextCounterNumber({ counter_id: 'skillscertificate_keyno' }).then(function (response) {
//                        stateService.go('skillscertificate', {
//                            labour_no: vm.model.setting.labour_no,
//                            skillscertificate_keyno: response[0].nextnumber
//                        });
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true,
//                disabled: function () {
//                    if (vm.model.setting.labour_no !== '0') {
//                		return false;
//                	} else {
//                		return 'hidden';
//                	}
//                }
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await skillsCertificatesService.getSkillsCertificates({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2505,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
